import { AddOnsTemplate } from '@/components/add-ons/template';
import { GalleriesItem } from '@/components/galleries/item';
import { GalleriesList } from '@/components/galleries/list';
import { ComponentsHead } from '@/components/head';
import { StaticImage } from 'gatsby-plugin-image';
import { FC } from 'react';
import { SwiperSlide } from 'swiper/react';

export const SPARKMAN_WHARF_TITLE = 'Sparkman Wharf';

export const Head = () => {
  return (
    <ComponentsHead
      title="Sparkman Wharf Boat Charter | Dockside Dining in Tampa"
      description="Pull up to Sparkman Wharf in style. Our private charters let you dock steps from food, cocktails, and live music in one of Tampa’s hottest hangout spots."
      keywords="Sparkman Wharf, Food & Drink, Dock-and-Dine, Nightlife"
    />
  );
};

const Page: FC = () => {
  return (
    <AddOnsTemplate
      title="Boat to Sparkman Wharf – Tampa’s Dockside Dining & Drinks Destination"
      subtitle={SPARKMAN_WHARF_TITLE}
    >
      <GalleriesList>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${SPARKMAN_WHARF_TITLE} header`}
              src="../../images/destinations/sparkman-wharf/0.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${SPARKMAN_WHARF_TITLE} slide 1`}
              src="../../images/destinations/sparkman-wharf/1.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${SPARKMAN_WHARF_TITLE} slide 2`}
              src="../../images/destinations/sparkman-wharf/2.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
      </GalleriesList>
    </AddOnsTemplate>
  );
};

export default Page;
